<tg-row>
    <tg-col>
        <h1>Add photos and media</h1>
    </tg-col>
</tg-row>
<property-photo-section></property-photo-section>

<div class="property-photos-page__section-container--large-margin">
    <property-video-section></property-video-section>
</div>
<div class="property-photos-page__section-container--large-margin">
    <property-3d-tour-section></property-3d-tour-section>
</div>
